import axios from 'axios'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'

interface getUserPlansProps {
  locale: PageLocaleEnum
}

export const getUserPlans = ({ locale }: getUserPlansProps) => {
  return axios.get(`/api/user-plans/${locale}`)
}
